import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';
import { OUTDATED_EVENT } from '../collab/protocol';

/** Shown when the server asks this tab to reload: a newer Vatman changed what documents hold. */
export function UpdateBanner() {
  const { t } = useTranslation();
  const [outdated, setOutdated] = useState(false);
  useEffect(() => {
    const on = () => setOutdated(true);
    window.addEventListener(OUTDATED_EVENT, on);
    return () => window.removeEventListener(OUTDATED_EVENT, on);
  }, []);
  if (!outdated) return null;
  return (
    <div className="update-banner" role="alert">
      <span>{t('update.text')}</span>
      <button className="btn sm primary" onClick={() => location.reload()}>
        <RefreshCw size={14} /> {t('update.reload')}
      </button>
    </div>
  );
}
